import './CoralGrantsFundingColumnCards.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebGrantsFundingColumnCards } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { CoralMasterCard } from '../../../coral-library/cards/Coral/ContentCard/CoralMasterCard'

type CoralGrantsFundingColumnCards = ReturnType<typeof mapCoralWebGrantsFundingColumnCards>

const visuals: CoralMasterCardVisuals = {
  headlineSize: 'h3-sm',
  contentContainerColor: 'off-white',
  contentPadding: '3xl',
  paddingList: '3xl',
  imageOrientation: 'top',
  listSize: 'body-sm',
  paddingBody: '3xl',
  bodySize: 'body-sm',
  radius: 4,
}

export const CoralGrantsFundingColumnCards: FC<CoralGrantsFundingColumnCards> = (props) => {
  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-grants-funding-column-cards'}>
        <CoralHeading description={props.description} header={props.header} headerTag={'0'} />
        <div className={'coral-grants-funding-column-cards__cards'}>
          <CoralCardsSlider forceRow={true}>
            {props.cards.map((card, index) => (
              <CoralMasterCard key={index} visuals={visuals} {...card} />
            ))}
          </CoralCardsSlider>
        </div>
      </div>
    </div>
  )
}
